var MDB = window.MDB || {};;
(function($) {
    "use strict";

    $.extend(MDB, {
        prompt: function(title, textBody, callback) {
            MDB.promptImpl(false, title, textBody, callback);
        },
        promptWithIcon: function(title, htmlBody, iconClass, callback) {
            MDB.promptImpl(true, title, htmlBody, callback, iconClass);
        },
        promptHtml: function(title, htmlBody, callback) {
            MDB.promptImpl(true, title, htmlBody, callback);
        },
        promptImpl: function(bodyIsHtml, title, body, callback, icon) {
            if (typeof(body) === 'function' && !callback) {
                callback = body;
                body = title;
                title = '';
            }

            var html = ['<div class="modal fade" style="z-index: 99999999999;">',
                '<div class="modal-dialog">',
                '  <div class="modal-content">',
                '    <div class="modal-header">',
                '      <h4 class="modal-title">Modal title</h4>',
                '      <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>',
                '    </div>',
                '    <div class="modal-body">',
                '      <p></p>',
                '    </div>',
                '    <div class="modal-footer">',
                '      <button type="button" class="btn btn-default" data-dismiss="modal">' + MDB.loadResourceString('Bool_No') + '</button>',
                '      <button type="button" class="btn btn-primary">' + MDB.loadResourceString('Bool_Yes') + '</button>',
                '    </div>',
                '  </div><!-- /.modal-content -->',
                '</div><!-- /.modal-dialog -->',
                '</div>'].join('');
            
            html = $(html);
            var titleElement = html.find('.modal-title');

            if (!title) {
                titleElement.remove();
            } else {
                if (icon) {
                    html.find('.modal-title').html('<i class="' + icon + '"></i> ' + title);
                } else {
                    titleElement.text(title);
                }
            }   
            

            if(bodyIsHtml) {
                html.find('.modal-body p').append(body);
            } else {
                html.find('.modal-body p').text(body);
            }

            html.bind('hidden.bs.modal', function() {
                html.remove();
                html = null;
            });
            html.find('.btn-default').bind('click', function() {
                callback(false); 
            });
            html.find('.btn-primary').bind('click', function () {
                html.modal('hide');
                callback(true);
            });
            html.appendTo('body');
            html.modal('show');
        }
    });
})(jQuery);